import apiClient from "@/clients/apiClient";
import type { GenContenidoNosotrosPayload } from "../interfaces/genContenidoNosotros.interface";

type ApiEnvelope<T> = { data: T; message: string; status: number };

export async function uploadTarjetaImagenAction(
  orden: number,
  file: File
): Promise<GenContenidoNosotrosPayload> {
  const fd = new FormData();
  fd.append("file", file);

  const res = await apiClient.post<ApiEnvelope<GenContenidoNosotrosPayload>>(
    `genContenidoNosotros/tarjeta/${orden}/imagen`,
    fd,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return res.data.data;
}

export async function removeTarjetaImagenAction(
  orden: number
): Promise<GenContenidoNosotrosPayload> {
  const res = await apiClient.delete<ApiEnvelope<GenContenidoNosotrosPayload>>(
    `genContenidoNosotros/tarjeta/${orden}/imagen`
  );
  return res.data.data;
}
